<template>
  <CenteredPageContainer :class="$style.page">
    <BreadcrumbList :links="breadcrumbs" />
    <section :class="[$style.page__section, $style.section]">
      <p v-if="!loading && !article">記事の読み込みに失敗しました</p>
      <AdminNewsDetail :articleDetail="article" v-if="article" />
    </section>
    <DirectionalLink
      :class="$style.page__prevlink"
      text="一覧に戻る"
      :to="{ name: 'news' }"
      direction="prev"
    />
  </CenteredPageContainer>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useHead } from '@unhead/vue'

import CenteredPageContainer from '@/components/molecules/CenteredPageContainer.vue'
import BreadcrumbList from '@/components/molecules/BreadcrumbList.vue'
import DirectionalLink from '@/components/atoms/DirectionalLink.vue'
import AdminNewsDetail from './AdminNewsDetail.vue'

import { useAdminNewsDetailPageQuery } from './AdminNewsDetailPage.generated'

import type { BreadCrumbLink } from '@/types/app'

const route = useRoute('newsDetail')
const id = route.params.newsId

const { result, loading } = useAdminNewsDetailPageQuery({
  id: id.toString(),
})

const article = computed(() => {
  return result.value?.newsForPlannerById
})

const breadcrumbs = computed((): ReadonlyArray<BreadCrumbLink> => {
  const breadcrumbs = route.meta.breadcrumbs ?? []
  return article.value != null
    ? [...breadcrumbs, { href: '', text: article.value.title }]
    : breadcrumbs
})

useHead({
  title: () =>
    article.value != null ? `${article.value.title} | お知らせ` : 'お知らせ',
})
</script>

<style lang="scss" module>
.page {
  &__section {
    &:nth-child(n + 2) {
      margin-top: 40px;
    }
  }

  &__prevlink {
    display: block;
    margin-top: 32px;
  }
}

.section {
  padding: 32px 40px;
  background: $color-surface-primary;
  border-radius: $border-radius-v2-rounder;
  box-shadow: $shadow-24;
}
</style>
